import React from 'react';
import loadingImage from '../../assets/img/undraw_loading_animation.svg';

const LoadingStatic = ({title = 'Analizando...', subtitle = 'Por favor, no cierres la página.'}) => {

    return (
        <div className="flex flex-col items-center justify-center h-full w-full px-6">
            <p className="text-2xl font-bold text-center text p-4">{title}</p>
            <p className="mt-2 text-lg text-center text-gray-700 mb-6">{subtitle}</p>
            <img src={loadingImage} alt="Loading" className="h-1/4 w-1/4 mt-4" />
        </div>
    );
};

export default LoadingStatic;